// List of organizationIds for which we should return a fallback InCreation
// response when a client abort / network error happens (no error.status).
// Keep this list synchronized with the API server configuration where applicable.
export const BYPASS_TIMEOUT_CREATION_ORGANIZATION_ID_LIST: number[] = import.meta.env[
    "VITE_BYPASS_TIMEOUT_CREATION_ORGANIZATION_ID_LIST"
]
    ? import.meta.env["VITE_BYPASS_TIMEOUT_CREATION_ORGANIZATION_ID_LIST"]?.split(";").map(Number)
    : [];

export const isBypassedOrganization = (organizationId?: number): boolean => {
    return (
        !!organizationId && BYPASS_TIMEOUT_CREATION_ORGANIZATION_ID_LIST.includes(organizationId)
    );
};
